import { CountMedalsData } from '@/store';
import { GDTApiErrors } from '@/types';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const getMedals = axiosErrorHandler(async () => {
  const url = `${URLs.MEDALLERO_COUNT}`;
  const response = await axiosGdt.post<CountMedalsData | GDTApiErrors>(url);

  return response.data;
}, TEXTS.defaultError);
